import Navbar from "../components/Navbar";
import SecondNavbar from "../components/SecondNavbar";
import Footer from "../components/Footer";
import ProtectedWrapper from "../components/ProtectedWrapper";
 import FeedbackContent from "./feedbackContent";
const Feedback = () => {
  return (
    <>
      <Navbar />
      <SecondNavbar />

      <ProtectedWrapper isLoggedIn={!!localStorage.getItem("token")}>
        <FeedbackContent />
      </ProtectedWrapper>

      <Footer />
    </>
  );
};

export default Feedback;